export default {
    namespaced: true,
    state: {
        showConfiguration: false,
        showPrivacy: false,
        showChanges: false,
        showComments: false,
        creationEnabled: false,
        showParticipants: false,
        layout: 'COLUMNS',
        cardSize: 'SMALL',
        order: 'REVERSE',
        shareURL: undefined,
        shareTitle: undefined,
        shareDescription: undefined,
        PROJECT_TYPE: [
            {
                name: 'COLLECTION',
                type: 'collection',
                image: require('@/assets/images/wall@3x.png'),
                available: true,
            },
            {
                name: 'TIME_MACHINE',
                type: 'timemachine',
                image: require('@/assets/images/timemachine@3x.png'),
                available: false,
            },
            {
                name: 'MAP',
                type: 'collection',
                image: require('@/assets/images/contentmap@3x.png'),
                mode: 'map',
                available: true,
            },
            {
                name: 'STORYTELLING',
                image: require('@/assets/images/storytelling@3x.png'),
                type: 'storytelling',
                available: false,
            },
            {
                name: 'QUIZ',
                type: 'trivial',
                image: require('@/assets/images/trivial@3x.png'),
                available: true,
            },
            {
                name: 'GEOQUIZ',
                type: 'trivial',
                image: require('@/assets/images/trivialgeo@3x.png'),
                mode: 'map',
                available: true,
            },
            {
                name: 'TREASUREHUNT',
                type: 'treasurehunt',
                image: require('@/assets/images/treasurehunt@3x.png'),
                available: true,
            },
        ],
        showObjectList: false,
    },
    mutations: {
        TOGGLE_CONFIGURATION(state) {
            state.showConfiguration = !state.showConfiguration;
        },
        TOGGLE_PRIVACY(state) {
            state.showPrivacy = !state.showPrivacy;
        },
        TOGGLE_CHANGES(state) {
            state.showChanges = !state.showChanges;
        },
        TOGGLE_COMMENTS(state) {
            state.showComments = !state.showComments;
        },
        TOGGLE_PARTICIPANTS(state) {
            state.showParticipants = !state.showParticipants;
        },
        HIDE_MENU(state) {
            state.showPrivacy = false;
            state.showConfiguration = false;
            state.showChanges = false;
            state.showComments = false;
            state.showParticipants = false;
            state.showObjectList = false;
        },
        ENABLE_CREATION(state) {
            state.creationEnabled = true;
        },
        DISABLE_CREATION(state) {
            state.creationEnabled = false;
        },
        CHANGE_LAYOUT(state, layout) {
            state.layout = layout;
        },
        CHANGE_CARD_SIZE(state, size) {
            state.cardSize = size;
        },
        CHANGE_PROJECT_LAYOUT(state, layout) {
            state.layout = layout;
        },
        CHANGE_PROJECT_ORDER(state, order) {
            state.order = order;
        },
        TOGGLE_OBJECT_LIST(state) {
            state.showObjectList = !state.showObjectList;
        },
    },
    actions: {
        toggleConfiguration({ commit }) {
            commit('TOGGLE_CONFIGURATION');
        },
        togglePrivacy({ commit }) {
            commit('TOGGLE_PRIVACY');
        },
        toggleChanges({ commit }) {
            commit('TOGGLE_CHANGES');
        },
        toggleComments({ commit }) {
            commit('TOGGLE_COMMENTS');
        },
        toggleParticipants({ commit }) {
            commit('TOGGLE_PARTICIPANTS');
        },
        hideMenu({ commit }) {
            commit('HIDE_MENU');
        },
        enableCreation({ commit }) {
            commit('ENABLE_CREATION');
        },
        disableCreation({ commit }) {
            commit('DISABLE_CREATION');
        },
        changeLayout({ commit }, layout) {
            commit('CHANGE_LAYOUT', layout);
        },
        changeCardSize({ commit }, size) {
            commit('CHANGE_CARD_SIZE', size);
        },
        changeProjectLayout({ commit }, layout) {
            commit('CHANGE_PROJECT_LAYOUT', layout);
            if (layout == 'VERTICAL') {
                commit('CHANGE_PROJECT_ORDER', 'FORWARD');
            }
        },
        toggleObjectList({ commit }) {
            commit('TOGGLE_OBJECT_LIST');
        },
    },
    getters: {
        showPrivacy: (state) => state.showPrivacy,
        showConfiguration: (state) => state.showConfiguration,
        showChanges: (state) => state.showChanges,
        showComments: (state) => state.showComments,
        showParticipants: (state) => state.showParticipants,
        shareURL: (state) => state.shareURL,
        shareDescription: (state) => state.shareDescription,
        shareTitle: (state) => state.shareTitle,
        showMenu: (state) =>
            state.showPrivacy ||
            state.showConfiguration ||
            state.showChanges ||
            state.showComments ||
            state.showParticipants ||
            state.showObjectList,
        creationEnabled: (state) => state.creationEnabled,
        layout: (state) => {
            return state.layout || 'GRID';
        },
        cardSize: (state) => state.cardSize || 'SMALL',
        order: (state) => state.order || 'REVERSE',
        showObjectList: (state) => state.showObjectList,
    },
};
